import type { SxProps, Theme } from "@mui/material/styles";
export const track: SxProps<Theme> = { height: 5, borderRadius: 1, bgcolor: "background.default", overflow: "hidden" };
export const fill = (percent: number): SxProps<Theme> => ({ height: "100%", borderRadius: 1, bgcolor: "primary.main", width: `${percent}%`, transition: "width 0.3s ease" });
